import { RequestController } from '@/business/modules/request';

const actions = {
	getRequestInstance() {
		return new RequestController();
	},

	setTab(tab) {
		this.tab = tab;
	},

	/* user */
	getDoneReserveTimeUser(page) {
		return this.getRequestInstance().getDoneReserveTimeUser(page);
	},

	getFutureReserveTimeUser(page) {
		return this.getRequestInstance().getFutureReserveTimeUser(page);
	},

	getPendReserveTimeUser(page) {
		return this.getRequestInstance().getPendReserveTimeUser(page);
	},

	getCanceledReserveTimeUser(page) {
		return this.getRequestInstance().getCanceledReserveTimeUser(page);
	},
	/* user */

	/* business */
	getPendReserveInBusinessBook(page: number) {
		return this.getRequestInstance().getPendReserveInBusinessBook(page);
	},

	getPendReservePreviewInBusinessBook() {
		return this.getRequestInstance().getPendReservePreviewInBusinessBook();
	},

	getFutureReserveInBusinessBook(page: number) {
		return this.getRequestInstance().getFutureReserveInBusinessBook(page);
	},

	getDoneReserveInBusinessBook(page: number) {
		return this.getRequestInstance().getDoneReserveInBusinessBook(page);
	},
	/* business */

	acceptReserveTime(id: string) {
		return this.getRequestInstance().acceptReserveTime(id);
	},

	rejectReserveTime(id: string) {
		return this.getRequestInstance().rejectReserveTime(id);
	},

	markNoShow(id: string) {
		return this.getRequestInstance().markNoShow(id);
	},

	cancelReserve(id: string) {
		return this.getRequestInstance().cancelReserve(id);
	},

	getBookingSuggestions(payload) {
		return this.getRequestInstance().getBookingSuggestions(payload);
	},

	joinWaitlist(payload) {
		return this.getRequestInstance().joinWaitlist(payload);
	},

	getTimeOfBusiness(data: object) {
		return this.getRequestInstance().getTimeOfBusiness(data);
	},

	redirectToPayment(payload) {
		return this.getRequestInstance().redirectToPayment(payload);
	},

	reserveWithoutPayment(payload) {
		return this.getRequestInstance().reserveWithoutPayment(payload);
	},

	inquiryPayment(data) {
		return this.getRequestInstance().inquiryPayment(data);
	},

	getRequestDetail(requestId: string, source: 'receive' | 'send' = 'receive') {
		return this.getRequestInstance().getRequestDetail(requestId, source);
	},

	payWithWallet(payload) {
		return this.getRequestInstance().payWithWallet(payload);
	},

	getWaitlistOffer(token: string) {
		return this.getRequestInstance().getWaitlistOffer(token);
	},
};

export default actions;
